import type { User } from "../../types/admin/UserTypes";
import type { LegacyUserId } from "../../types/identity";
import { getSessionUser } from "./sessionUser";

// labiq keeps integer user ids (contract §10), so every labiq-bound user reference converts here and nowhere else.
export const labiqUserId = (user: Pick<User, "legacy_user_id"> | null | undefined): LegacyUserId | undefined =>
	user?.legacy_user_id ?? undefined;

export const sessionLabiqUserId = (): LegacyUserId | undefined => labiqUserId(getSessionUser());

// labiq reads `patient.id` as its integer user reference (report PDFs are filed under it), so it gets the legacy id there.
export const toLabiqPatient = <T extends Pick<User, "id" | "legacy_user_id">>(patient: T): Omit<T, "id"> & { id: LegacyUserId | undefined } => ({
	...patient,
	id: labiqUserId(patient),
});

// For labiq writes whose request needs the id: a missing legacy id fails the write instead of sending null.
export const requireLabiqUserId = (user: Pick<User, "legacy_user_id"> | null | undefined): LegacyUserId => {
	const id = labiqUserId(user);
	if (id === undefined) {
		console.error("labiq.legacy_user_id.missing");
		throw new Error("This account has no lab user id.");
	}
	return id;
};
